export default __webpack_public_path__ + "static/upper2_1-c162b9fcea5a832d4c9d13dc96bd1276.jpg";